import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Table, Button, Badge, Alert, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { FaEdit, FaTrash, FaEye } from 'react-icons/fa';

const MyBlogsPage = () => {
    const { currentUser } = useAuth();
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchMyBlogs = async () => {
            try {
                const response = await fetch('/api/blogs/admin/my-blogs', {
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    }
                });
                const data = await response.json();

                console.log('📊 My Blogs API Response:', data);

                if (data.success) {
                    setBlogs(data.data.blogs || []);
                } else {
                    setError(data.message || 'Bloglar yüklenemedi');
                }
            } catch (err) {
                console.error('My blogs fetch error:', err);
                setError('Bağlantı hatası');
            } finally {
                setLoading(false);
            }
        };

        if (currentUser) {
            fetchMyBlogs();
        }
    }, [currentUser]);

    const deleteBlog = async (blogId, blogTitle) => {
        try {
            setLoading(true);
            const response = await fetch(`/api/blogs/admin/delete/${blogId}`, {
                method: 'DELETE',
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });

            const data = await response.json();

            if (data.success) {
                // State'den blogu çıkar
                setBlogs(prevBlogs => prevBlogs.filter(blog => blog._id !== blogId));
                // Success feedback (opsiyonel)
                console.log(`✅ "${blogTitle}" başarıyla silindi`);
            } else {
                setError(data.message || 'Blog silinemedi');
                console.error('❌ Silme hatası:', data.message);
            }
        } catch (err) {
            console.error('Delete blog error:', err);
            setError('Blog silinirken hata oluştu');
        } finally {
            setLoading(false);
        }
    };

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString('tr-TR');
    };

    const getStatusBadge = (status) => {
        switch (status) {
            case 'published': return <Badge bg="success">Yayınlanmış</Badge>;
            case 'draft': return <Badge bg="warning">Taslak</Badge>;
            case 'archived': return <Badge bg="secondary">Arşivlenmiş</Badge>;
            default: return <Badge bg="light">{status}</Badge>;
        }
    };

    if (loading) {
        return (
            <Container className="py-5 text-center">
                <Spinner animation="border" />
                <p className="mt-2">Bloglar yükleniyor...</p>
            </Container>
        );
    }

    return (
        <Container className="py-5">
            <Row>
                <Col>
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <h1>Bloglarım</h1>
                        <Link to="/admin/create-blog" className="btn btn-primary">
                            Yeni Blog Yazısı
                        </Link>
                    </div>

                    {error && <Alert variant="danger">{error}</Alert>}

                    {blogs.length === 0 ? (
                        <Alert variant="info" className="text-center">
                            <h4>Henüz blog yazınız yok</h4>
                            <p>İlk blog yazınızı oluşturmak için başlayın!</p>
                            <Link to="/admin/create-blog" className="btn btn-primary">
                                Blog Yazısı Oluştur
                            </Link>
                        </Alert>
                    ) : (
                        <Table responsive striped hover>
                            <thead>
                                <tr>
                                    <th>Başlık</th>
                                    <th>Kategori</th>
                                    <th>Durum</th>
                                    <th>Tarih</th>
                                    <th>İşlemler</th>
                                </tr>
                            </thead>
                            <tbody>
                                {blogs.map((blog) => (
                                    <tr key={blog._id}>
                                        <td>
                                            <strong>{blog.title}</strong>
                                            {blog.isFeatured && <Badge bg="warning" className="ms-2">Öne Çıkan</Badge>}
                                            {blog.isSticky && <Badge bg="info" className="ms-2">Sabit</Badge>}
                                        </td>
                                        <td>{blog.categoryName || blog.category}</td>
                                        <td>{getStatusBadge(blog.status)}</td>
                                        <td>{formatDate(blog.createdAt)}</td>
                                        <td>
                                            <div className="d-flex gap-2">
                                                {blog.status === 'published' && (
                                                    <Link
                                                        to={`/blog/${blog.slug}`}
                                                        className="btn btn-outline-primary btn-sm"
                                                        title="Görüntüle"
                                                    >
                                                        <FaEye />
                                                    </Link>
                                                )}
                                                <Link
                                                    to={`/admin/edit-blog/${blog._id}`}
                                                    className="btn btn-outline-secondary btn-sm"
                                                    title="Düzenle"
                                                >
                                                    <FaEdit />
                                                </Link>
                                                <Button
                                                    variant="outline-danger"
                                                    size="sm"
                                                    title="Sil"
                                                    onClick={() => {
                                                        if (window.confirm('Bu blog yazısını silmek istediğinizden emin misiniz?')) {
                                                            deleteBlog(blog._id, blog.title);
                                                        }
                                                    }}
                                                >
                                                    <FaTrash />
                                                </Button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    )}
                </Col>
            </Row>
        </Container>
    );
};

export default MyBlogsPage;